"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = require("./Box");
var typography_1 = require("./typography");
function Toast(_a) {
    var children = _a.children, _b = _a.kind, kind = _b === void 0 ? 'info' : _b, onClick = _a.onClick;
    return (react_1.default.createElement(Box_1.Box, { background: kindToBackground[kind], borderRadius: '$12px', onClick: onClick, spaceHorz: '$12px', spaceVert: '$4px' },
        react_1.default.createElement(typography_1.Text, { color: kind !== 'info' ? '$white' : undefined, size: '$10px' }, children)));
}
exports.Toast = Toast;
var kindToBackground = {
    info: '$grey4',
    action: '$focus',
    success: '$success',
    failure: '$failure',
};
